
define('inlineSvg!svgs/icon/close-central', function () {return '<span class="inline-close-central inline-icon"><svg width="30" height="30"><path d="M21 9.8l-.8-.8-5.2 4.8L9.8 9l-.8.8 4.8 5.2L9 20.2l.8.8 5.2-4.8 5.2 4.8.8-.8-4.8-5.2L21 9.8"/></svg></span>';});

